import store from '../../store/store';

const isAuthenticated = async (to, from, next) => {
  const refreshToken = localStorage.getItem(process.env.VUE_APP_JWT_REFRESH);

  if (!store.getters['auth/isAuthenticated'] && refreshToken) {
    await store.dispatch('auth/refreshSession', { refreshToken: refreshToken }).catch(() => {
      next({ name: 'logout' });
    });
  }

  if (store.getters['auth/isAuthenticated']) {
    next();
    return;
  }

  next({ name: 'login' });
};

const isNotAuthenticated = (to, from, next) => {
  if (!store.getters['auth/isAuthenticated']) {
    next();
    return;
  }
  next({ name: 'search' });
};

export { isNotAuthenticated, isAuthenticated };
